import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { VisitorAuthProvider } from "@/context/VisitorAuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import { initLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Legal from "@/pages/Legal";
import AuthCallback from "@/pages/AuthCallback";

function ScrollManager() {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (!state?.scrollTo) window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Process OAuth session_id FIRST (synchronous render check prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/properties" element={<Properties />} />
      <Route path="/properties/:id" element={<PropertyDetail />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/privacy-policy" element={<Legal type="privacy" />} />
      <Route path="/terms" element={<Legal type="terms" />} />
      <Route path="/disclaimer" element={<Legal type="disclaimer" />} />
    </Routes>
  );
}

function Shell() {
  const { pathname, hash } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isCallback = hash?.includes("session_id=");

  return (
    <>
      <ScrollManager />
      {!isAdmin && !isCallback && <Navbar />}
      <AppRouter />
      {!isAdmin && !isCallback && <Footer />}
      {!isAdmin && !isCallback && <WhatsAppFloat />}
      <Toaster position="top-center" richColors />
    </>
  );
}

export default function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <ConfigProvider>
      <AuthProvider>
        <VisitorAuthProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </VisitorAuthProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}
